module.exports = __webpack_public_path__ + "img/chamada.6ad03476.jpg";